import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import "../assets/stylesheets/Games.scss";

@inject('Navigator', 'ConfigStore', 'SchoolStore')
@observer
export default class Games extends Component {

    goTo(uri, e) {
        this.props.ConfigStore.animationType = "right";
        this.props.Navigator.push(uri);
    }

    render() {
        return (
            <div className="Games Page">
                <div className="container">
                    <div className="text">
                        <h1>Games</h1>
                        <button
                            name={"game1"}
                            className="btn-answer"
                            key={1}
                            onClick={this.goTo.bind(this, "/game")}>GAME 1</button>
                        <button
                            name={"game2"}
                            className="btn-answer"
                            key={2}
                            onClick={this.goTo.bind(this, "/game2")}>GAME 2</button>
                        <button
                            name={"game3"}
                            className="btn-answer"
                            key={3}
                            onClick={this.goTo.bind(this, "/game3")}>GAME 3</button>
                        <button
                            name={"game4"}
                            className="btn-answer"
                            key={4}
                            onClick={this.goTo.bind(this, "/game4")}>GAME 4</button>
                    </div>
                </div>
            </div>
        )

    }

}


// WEBPACK FOOTER //
// ./src/containers/Games.js